import { render, staticRenderFns } from "./AccountMigrator.vue?vue&type=template&id=7438d26e&"
import script from "./AccountMigrator.vue?vue&type=script&lang=js&"
export * from "./AccountMigrator.vue?vue&type=script&lang=js&"
import style0 from "./AccountMigrator.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports